<mat-card class="error">
  <mat-card-content class="error__content">
    <div class="error__message">
      <div>
        <ng-container i18n="Availability error message; part 1|Displayed when the API request fails"
          >There was an error while getting the availability.</ng-container
        >
        {{ ' ' }}
        <ng-container i18n="Availability error message; part 2|Displayed when the API request fails"
          >Please try again or contact the administrator.</ng-container
        >
      </div>

      <div *ngIf="errorMessage">
        <ng-container i18n="Availability error label|Displayed when the API request fails">Message</ng-container> :
        {{ errorMessage }}
      </div>
    </div>

    <button mat-raised-button color="primary" class="error__button" (click)="reload()">
      <ng-container i18n="Availability error retry button|Displayed when the API request fails">Retry</ng-container>
    </button>
  </mat-card-content>
</mat-card>
